import { AlertTriangle, CheckCircle2, Wand2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function ContrastIssues({ issues, onFix, testPrefix = "contrast" }) {
  if (!issues?.length) {
    return (
      <div className="flex items-center gap-2 rounded-md border border-emerald-200 bg-emerald-50 px-3 py-2 text-sm text-emerald-800" data-testid={`${testPrefix}-ok`}>
        <CheckCircle2 className="h-4 w-4 shrink-0" aria-hidden /> Every colour pair meets WCAG AA contrast.
      </div>
    );
  }
  return (
    <div role="alert" className="rounded-md border border-amber-300 bg-amber-50 p-3" data-testid={`${testPrefix}-issues`}>
      <div className="flex items-center gap-2 text-sm font-semibold text-amber-900">
        <AlertTriangle className="h-4 w-4 shrink-0" aria-hidden />
        {issues.length === 1 ? "1 colour needs attention" : `${issues.length} colours need attention`}
      </div>
      <ul className="mt-1.5 list-disc space-y-1 pl-6 text-sm text-amber-900">
        {issues.map((i) => <li key={i.code}>{i.message}</li>)}
      </ul>
      <p className="mt-1.5 text-xs text-amber-900">You can&apos;t save until these are fixed.</p>
      <Button size="sm" variant="outline" className="mt-2 bg-white" onClick={onFix} data-testid={`${testPrefix}-autofix-btn`}>
        <Wand2 className="h-3.5 w-3.5" aria-hidden /> Use accessible colours
      </Button>
    </div>
  );
}

export const mergeFixes = (issues) => issues.reduce((acc, i) => ({ ...acc, ...i.fix }), {});
